import './index.scss';
import classNames from 'classnames';
type CustomBadge1PropsType = {
  title: string;
  isDisable?: boolean;
  type?:
    | 'primary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'purple'
    | 'secondary'
    | 'disable'
    | 'primary-r'
    | 'success-r'
    | 'danger-r'
    | 'warning-r'
    | 'purple-r'
    | 'secondary-r'
    | string;
  widthSize?: 'sm-badges' | 'md-badges' | 'lg-badges';
  onClick?: () => void;
};

const CustomBadges = ({
  title,
  isDisable,
  type = 'success',
  widthSize = 'md-badges',
  onClick
}: CustomBadge1PropsType) => {
  return (
    <section onClick={isDisable ? () => false : onClick} id='custom-badge-1-container'>
      <p className={classNames(type, widthSize)}>{title}</p>
    </section>
  );
};

export default CustomBadges;
